import React, { useContext, useEffect, useState, useId } from "react";
import { MdOutlineArrowForwardIos, MdArrowBackIosNew } from "react-icons/md";
import { getInterviewQuestions } from "services/api";
import { CommonContext } from "hooks/CommonContext";
import { parseQuestionAnswers } from "utils/commonUtils";
import { injectDrawerStyles } from "./drawerStyles";

injectDrawerStyles();

const AskQuestionSection = () => {
  const { room_id } = useContext(CommonContext);
  const [questionAnswerJson, setQuestionAnswerJson] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const idHook = useId();
  const visibleButtonsCount = 3;

  useEffect(() => {
    getInterviewQuestions(room_id)
      .then((response) => {
        if (response.data.status === "ERROR") {
          window.alert(response.data.statusDesc);
        } else {
          setQuestionAnswerJson(parseQuestionAnswers(response.data));
        }
      })
      .catch((err) => console.error(err));
  }, [room_id]);

  const handlePrevious = () => { if (currentPage > 0) setCurrentPage(currentPage - 1); };
  const handleNext = () => { if (currentPage < questionAnswerJson.length - 1) setCurrentPage(currentPage + 1); };

  if (questionAnswerJson.length === 0) {
    return (
      <>
        <div className="dw-header">
          <span className="dw-title">Q&amp;A</span>
        </div>
        <div className="dw-empty">No questions available.</div>
      </>
    );
  }

  const start = Math.max(0, currentPage - Math.floor(visibleButtonsCount / 2));
  const end = Math.min(start + visibleButtonsCount, questionAnswerJson.length);

  return (
    <>
      <div className="dw-header">
        <span className="dw-title">Q&amp;A</span>
        <span style={{ fontSize: "12px", color: "#6b7fa8" }}>
          {currentPage + 1} / {questionAnswerJson.length}
        </span>
      </div>

      <div className="dw-body">
        {/* Question */}
        <div className="dw-question">
          Q{currentPage + 1}. {questionAnswerJson[currentPage]?.question}
        </div>

        {/* Answers */}
        <ol className="dw-answers">
          {questionAnswerJson[currentPage]?.answers?.map((answer) => (
            <li key={idHook + answer}>{answer}</li>
          ))}
        </ol>

        {/* Pagination */}
        <div className="dw-pagination">
          <button
            className="dw-page-btn"
            onClick={handlePrevious}
            disabled={currentPage === 0}
            title="Previous"
          >
            <MdArrowBackIosNew />
          </button>

          {Array.from({ length: end - start }, (_, i) => start + i).map((page) => (
            <button
              key={`${idHook}-${page}`}
              className={`dw-page-btn${currentPage === page ? " dw-page-active" : ""}`}
              onClick={() => setCurrentPage(page)}
            >
              {page + 1}
            </button>
          ))}

          <button
            className="dw-page-btn"
            onClick={handleNext}
            disabled={currentPage === questionAnswerJson.length - 1}
            title="Next"
          >
            <MdOutlineArrowForwardIos />
          </button>
        </div>
      </div>
    </>
  );
};

export default AskQuestionSection;